import Layout from '@/layouts/BasicLayout/index.vue'
import { ROLE_TYPE } from '@/utils/roleControl'
import type { RouteRecordRaw } from 'vue-router'

/**
 * 数据报表
 */
const report: RouteRecordRaw = {
  path: '/report',
  name: 'Report',
  // redirect: '/report/sales',
  component: Layout,
  meta: {
    title: '数据报表',
    menuName: '业务管理报表',
    module: 'Report',
    icon: 'report|svg',
    menuOfRoleType: [ROLE_TYPE.ADMIN, ROLE_TYPE.BUSINESS]
  },
  children: [
    {
      path: 'inventory',
      name: 'InventoryStatistics',
      component: () => import('@/views/InventroyStatistics/index.vue'),
      meta: {
        title: '库存统计',
        menuName: '库存统计',
        module: 'INVENTORY_STATISTICS',
        menuOfRoleType: [ROLE_TYPE.ADMIN, ROLE_TYPE.BUSINESS],
        hidePageHeader:true
      }
    },
    // 销售统计
    {
      path: 'sales',
      name: 'SalesStatistics',
      component: () => import('@/views/report/sales/index.vue'),
      meta: {
        title: '销售统计',
        menuName: '销售统计',
        module: 'SalesStatistics',
        menuOfRoleType: [ROLE_TYPE.ADMIN, ROLE_TYPE.BUSINESS]
      }
    }
  ]
}

export default report
